/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { GuidanceId } from "../../commons/types/GuidanceId";
import { GuidanceOptions } from "./GuidanceOptions";
export const GuidanceResource = core.serialization.object({
    id: GuidanceId,
    guideSlug: core.serialization.string(),
    options: GuidanceOptions,
    createdFrom: GuidanceId.optional(),
    lastPropagatedAt: core.serialization.date().optional(),
});
